// 检疫证明
export const quarantine = {
  btnOrderDetail: 'n.692.1963.', // 订单详情页检疫证明按钮
  btnOrderList: 'n.691.1962.', // 订单列表页检疫证明按钮
  btnChooseOrder: 'n.785.1965.0', // 检疫证明订单选择页-选择订单
  btnPicture: 'n.786.1966.0' // 检疫结果页-检疫证明图片点击
}
